import { useHomeStore, useWalletStore } from '@/src/store';
import styles from './ToggleProController.module.scss';

export default function ToggleProController() {
    const { swProInterface, setSwProInterface } = useWalletStore();
    const handleTogglePro = () => {
        setSwProInterface(!swProInterface);
    };
    return (
        <div className={styles.toggleController}>
            {/* <p onClick={() => setSwProInterface(false)} className={`${styles.text} ${swProInterface === false ? styles.active : ''}`}>
                Basic
            </p> */}
            <div className={`${styles.toggle}`} onClick={handleTogglePro}>
                <span className={`${styles.point} ${swProInterface === false ? styles.active : ''}`}></span>
            </div>
            <p onClick={() => setSwProInterface(true)} className={`${styles.text} ${swProInterface === true ? styles.active : ''}`}>
                Pro
            </p>
        </div>
    );
}
